export interface AnnotatorTool {
    code : Type;
    quickAction? : {
        html : string;
        id? : string;
    };
    className : string;
    attachComment? : boolean;
    showTrash? : boolean;
    cursor? : string;
    legantoAnnotator? : boolean;
    disabled? : boolean;
    tooltip? : string;
}

export enum Type{
    "comment" = "CMT",
    "highlight" = "HL",
    "shape" = "SHAPE",
    "none" = ""
}